import ApiServer from "../ApiServer.js";
import * as INR from "../INR.ts";
import * as i18n from "../i18n.ts";
import * as modal from "../util/modal.ts";
import * as libLocation from "../lib/location.ts";
import * as FwDatas from "../FwDatas.ts";
import * as amplify from "../util/amplify.ts";
import * as im from "./im_datamanager.js";
import * as Html from "../util/Html.ts";
import * as Screen from "../lib/Screen.js";
import Icons from "../svg/Icons.ts";


import musThreadList from "./im_threadlist.mustache";
import musThreadContent from "./im_threadcontent.mustache";
import musMessages from "./im_messages.mustache";


import * as actionMenu from "../widget/action-menu-registry.ts"
import $ from "../$.js";

actionMenu.register({
  imthreadmenu:function(){
    return {
      menu:[
        {svg:Icons.ic_refresh,onclick:'imrefresh',i18nkey:'im.refresh'},
        {svg:Icons.ic_delete,color:'var(--red)',onclick:'deletethread',i18nkey:'im.deletethread'}
      ]
    };
  }
});



  ApiServer.customimmarkasread = ApiServer.immarkasread.prepare(function(){
    amplify.publish("notificationBulletDelta","imunreadthread",-1);
  });
  
  ApiServer["custom.imsendmessage"] = function(form,success,error){
    ApiServer.imsend(form,success,error);
    modal.closeModal();
  };

  
  function display(threads){
    Html.setHtml($("#thread-list"),musThreadList,{threads:threads});
    if(threads.length===0){
      $("#thread-pane img").fadeIn();
      
    }
  }
  var 
    layoutDisplayed = false;
  
  INR.onPage(INR.URL.IM,function(){
    layoutDisplayed = false;
    INR.subscribe("refreshThreadMessages",refreshThreadMessages);
    INR.subscribe("familyMemberSelected", function(event){
      
      Html.wait(function(){return layoutDisplayed},function(){
        im.withparticipant(event.selected,function(threadId){
          if(threadId){
            showthread(threadId,true);
          }else{
            Html.trigger("writeto",[event.selected]);  
          }
        });
      })
    });
    INR.subscribe("handleParam", function(event){
      showthread(libLocation.getURLParam('threadId'));
      var target = libLocation.getURLParam('target');
      if(target){
        amplify.publish("familyMemberSelected",{selected:target})
      }
    })
      
    
    im.withallthread(true,function(threads){
      display(threads);
      
      if(!Screen.isMobileView()){
        $("#thread-list").find(".fw-thread[data-fw-onclick]").first().trigger('click');  
      }
      layoutDisplayed = true;
      amplify.publish("handleParam")
      
    });
    
    
  });
  
  function hilightThreadSelector(threadId){
    $('.fw-thread.selected').removeClass('selected');
    var threadLink = $('.fw-thread[data-fw-meta-id=\''+threadId+'\']');
    threadLink.addClass('selected');
    threadLink.find('.fw-notification').fadeOut();
  }
  
  function showthread(threadId,focus){
    if(!threadId){
      $("#thread-pane").removeClass('open');
      return;
    }
    im.withfullthread(threadId,false,function(thread){
      hilightThreadSelector(threadId);
      
      Html.setHtml($("#thread-pane").addClass('open'),musThreadContent,thread);
      if(focus){
        $("#thread-pane").find("textarea").first().focus();
      }
      var container = $("#immessage-container").on('afterupdate',function(evt,delta){
        this.scrollTop =  this.scrollTop+ delta;
      }).get(0);
      //do it later because sometimes everything is is still at 0
      setTimeout(function(){container.scrollTop = container.scrollHeight},1);
      
      if(thread.isunRead()){
        thread.markAsRead();
        ApiServer.customimmarkasread(thread.metaId);
      }
      
      
    });
  }
  
  function refreshThreadMessages(threadId){
    im.withfullthread(threadId,true,function(thread){
      Html.setHtml($("#immessage-container"),musMessages,thread);
      var container = $("#immessage-container").on('afterupdate',function(evt,delta){
        this.scrollTop =  this.scrollTop+ delta;
      }).get(0);
      //do it later because sometimes everything is is still at 0
      setTimeout(function(){container.scrollTop = container.scrollHeight},1);
      
      
      
      if(thread.isunRead()){
        thread.markAsRead();
        ApiServer.customimmarkasread(thread.metaId);
      }
      
      
    });
  }
  function imloadolder(threadId,nextPageId){
    var node = this;
    im.withOlderMessages(threadId,nextPageId,function(thread){
      var nextNode = node.next();
      Html.setHtmlAtStart(node.parent(),musMessages,thread);
      node.remove();
      nextNode.prev().get(0).scrollIntoView();
    });
  }
  function imrefresh(){
    var currentThreadId = this.metaId();
    im.withallthread(false,function(threads){
      display(threads);
      hilightThreadSelector(currentThreadId);
      refreshThreadMessages(currentThreadId);
    });
  }
  amplify.subscribe("messageSent",function(message){
    im.withallthread(false,function(threads){
      display(threads);
      showthread(message.threadId||message.threadUsersToken,true);
    });
    
  });
  amplify.subscribe("mediaDeleted",function(mediaId){
    $(`*[data-fw-meta-id="${mediaId}"`).remove()
    
  });
  
  function deletethread(){
    var metaId = this.metaId();
    modal.confirmDelete('im.confirmdeletethread',function(){
      ApiServer.metadelete(metaId,libLocation.refresh);
    })
  }
  function writeto(targetId){
    var 
      proto = function(){},
      familyWithoutMe = new proto(),
      recipients = $.makeArray(arguments).map(function(o){return String(o);});
      
    proto.prototype = FwDatas.getFamily();
    familyWithoutMe.members = $.grep(FwDatas.getFamily().members,function(member,i){
      return (member.accountId !== FwDatas.getAccountId());
    });
    
    if(familyWithoutMe.members.length===0){
      modal.alert("errors.familyEmpty",function(){
        Html.trigger('invite');
      });
    } else {
      im.withparticipant(targetId,function(threadId){
        if(threadId){
          showthread(threadId,true);
        }else{
          import("../modal/new_message.mustache").then(function(TPL){
            modal.openModal(TPL,{accountid:recipients||"all",familyWithoutMe:familyWithoutMe});
          });
        }
        
      });
    }
  }
  Html.register({
    writeto,
    deletethread,
    imloadolder,
    showthread(threadId){
      if(Screen.isMobileView()){
        libLocation.goTo("?threadId="+threadId);
      }else{
        showthread(threadId)
      }
      
    },
    imrefresh
  });